import { useMemo } from "react";
import { useEPQuestionSearchQuery } from "src/modules/exam-preparation/graphql/question/questionSearch";
import { QuestionSearchSortBy } from "src/modules/exam-preparation/graphql/question/types";
import analytics from '../../analytics';
const listAnalytics = analytics.setWidget('Bookmarks').setTarget('QuestionList');
export default function useData(subjectID) {
    const [listQueryState, listQueryActions] = useEPQuestionSearchQuery({
        skip: !subjectID,
        listAnalytics,
    });
    const listQueryVars = useMemo(() => {
        if (!subjectID)
            return {};
        return {
            query: '',
            ancestorID: subjectID,
            withAncestorsDetails: false,
            bookmarked: true,
            sortBy: QuestionSearchSortBy.QP_DATE,
            includeDuplicates: true,
        };
    }, [subjectID]);
    const state = {
        listQuery: listQueryState,
        listQueryVars,
    };
    const actions = {
        listQuery: listQueryActions,
    };
    return [state, actions];
}
